import { format, startOfDay } from "date-fns"

export function generateTimeSlots(interval = 15): string[] {
	const times: string[] = []
	for (let hour = 0; hour < 24; hour++) {
		for (let minutes = 0; minutes < 60; minutes += interval) {
			const hh = hour.toString().padStart(2, "0")
			const mm = minutes.toString().padStart(2, "0")
			times.push(`${hh}:${mm}`)
		}
	}
	return times
}

export const generateAvailableTimeSlots = (selectedDate: string | null, interval = 15): string[] => {
  const times: string[] = []
  const now = new Date()

  for (let hour = 0; hour < 24; hour++) {
    for (let minutes = 0; minutes < 60; minutes += interval) {
      const slotDate = new Date(selectedDate!)
      slotDate.setHours(hour, minutes, 0, 0)

      if (selectedDate && startOfDay(selectedDate).getTime() === startOfDay(now).getTime()) {
        if (slotDate < now) continue
      }

      const hh = hour.toString().padStart(2, "0")
      const mm = minutes.toString().padStart(2, "0")
      times.push(`${hh}:${mm}`)
    }
  }
  return times
}

export const convertSeconds = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const leftSeconds = seconds - (minutes * 60)
  return `${minutes}:${leftSeconds < 10 ? `0${leftSeconds}` : leftSeconds}`
}

export const convertToMinutes = (timeStr: string) => {
  const hoursMatch = timeStr.match(/(\d+)\s*hour/);
  const minutesMatch = timeStr.match(/(\d+)\s*min/);

  const hours = hoursMatch ? parseInt(hoursMatch[1]) : 0;
  const minutes = minutesMatch ? parseInt(minutesMatch[1]) : 0;

  return hours * 60 + minutes;
}

export const convertHToMin = (hours: number, minutes: number) => {
  if (!hours && !minutes) return;
  else if (!hours) return minutes
  return 60 * hours + (minutes || 1)
}

export const convertMinToH = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const leftMinutes = minutes - (hours * 60)
  return hours > 0 ? `${hours} h ${leftMinutes} min` : `${leftMinutes} min`
}

export const getFormattedDate = (date: Date) => format(date, "MMM dd, yyyy HH:mm")